/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_TaglineInputs */

const en_svc_backend_development_tagline = /** @type {(inputs: Svc_Backend_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIs and services built for scale, not just for demos.`)
};

const ar_svc_backend_development_tagline = /** @type {(inputs: Svc_Backend_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واجهات برمجية وخدمات مبنية للتوسع، وليس مجرد عروض تجريبية.`)
};

const bn_svc_backend_development_tagline = /** @type {(inputs: Svc_Backend_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডেমোর জন্য নয়, স্কেলের জন্য তৈরি API ও সার্ভিস।`)
};

const de_svc_backend_development_tagline = /** @type {(inputs: Svc_Backend_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIs und Dienste, die auf Skalierung ausgelegt sind, nicht nur für Demos.`)
};

const es_svc_backend_development_tagline = /** @type {(inputs: Svc_Backend_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API y servicios creados para escalar, no solo para demostraciones.`)
};

const fr_svc_backend_development_tagline = /** @type {(inputs: Svc_Backend_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API et services conçus pour évoluer, pas seulement pour les démonstrations.`)
};

const pt_svc_backend_development_tagline = /** @type {(inputs: Svc_Backend_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIs e serviços desenvolvidos para escala, não apenas para demonstrações.`)
};

const zh_svc_backend_development_tagline = /** @type {(inputs: Svc_Backend_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 和服务是为了规模而构建的，而不仅仅是为了演示。`)
};

const tr_svc_backend_development_tagline = /** @type {(inputs: Svc_Backend_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca demolar için değil, ölçeklendirmek için oluşturulmuş API'ler ve hizmetler.`)
};

const ru_svc_backend_development_tagline = /** @type {(inputs: Svc_Backend_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API и сервисы, созданные для масштабирования, а не только для демонстраций.`)
};

const pl_svc_backend_development_tagline = /** @type {(inputs: Svc_Backend_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interfejsy API i usługi stworzone z myślą o skali, a nie tylko na potrzeby wersji demonstracyjnych.`)
};

/**
* | output |
* | --- |
* | "APIs and services built for scale, not just for demos." |
*
* @param {Svc_Backend_Development_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_tagline = /** @type {((inputs?: Svc_Backend_Development_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_tagline(inputs)
	if (locale === "bn") return bn_svc_backend_development_tagline(inputs)
	if (locale === "de") return de_svc_backend_development_tagline(inputs)
	if (locale === "es") return es_svc_backend_development_tagline(inputs)
	if (locale === "fr") return fr_svc_backend_development_tagline(inputs)
	if (locale === "pt") return pt_svc_backend_development_tagline(inputs)
	if (locale === "zh") return zh_svc_backend_development_tagline(inputs)
	if (locale === "tr") return tr_svc_backend_development_tagline(inputs)
	if (locale === "ru") return ru_svc_backend_development_tagline(inputs)
	if (locale === "pl") return pl_svc_backend_development_tagline(inputs)
	return en_svc_backend_development_tagline(inputs)
});
export { svc_backend_development_tagline as "svc_backend-development_tagline" }